import Backend from '@/app/Dataman-Backend';
import { toFileDownloadUrl } from './files_paths';

export { filesApiAdapter, filesFilterAdapter } from './files';

export const filesApi = {
  wimsFiles: {
    downloadByUrl: (downloadUrl) => {
      if (!downloadUrl) {
        return Promise.reject(new Error('File has no download link'));
      }
      return Backend.loadBlobData({
        url: toFileDownloadUrl(downloadUrl),
        method: 'get',
        responseType: 'blob',
      });
    },
  },
};
